import Money from '../money';
import EventEmitter, { EVENT_TYPES } from '@lib/eventEmitter';

interface MonthlyPaymentProps {
  amount: number;
  financeHeading?: string;
  prefix?: string;
  showTooltip?: boolean;
  stockReference?: string;
  vehicleUrl?: string;
}

const MonthlyPayment = ({
  financeHeading,
  stockReference,
  vehicleUrl,
  showTooltip = false,
  prefix,
  amount,
}: MonthlyPaymentProps) => {
  const openModal = (): void => {
    EventEmitter.emit(EVENT_TYPES.openModal, 'finance-illustration', {
      financeHeading,
      stockReference,
      vehicleUrl,
    });
  };

  const renderInlineIllustration = (): JSX.Element | null => {
    if (showTooltip && stockReference) {
      return (
        <button
          className="ac-finance__tooltip ac-finance__tooltip--hover ch-ml--1"
          onClick={openModal}
          type="button"
        >
          <span className="ch-reader">
            View this car&apos;s full finance example
          </span>
        </button>
      );
    }
    return null;
  };

  return (
    <span className="ac-pricing__monthly">
      {prefix && <span className="ac-pricing__prefix">{prefix}</span>}
      <Money amount={amount} />
      <span className="ac-pricing__suffix">
        <span className="ac-pricing__term">Per month</span>
        {renderInlineIllustration()}
      </span>
    </span>
  );
};

export default MonthlyPayment;
